<template>
	<div style="background: #f5f5f5; height: 100%">
		<NavBar
			title="行情走势"
		/>
		<PullRefresh v-model="refreshing" @refresh="onRefresh">
        <List v-model="loading" :finished="finished" finished-text="我是有底线的哦" @load="onLoad" sticky>
	        <trendCard v-for="(item, index) in list" :key="index" :data="item" />
        </List>
      </PullRefresh>
	</div>
</template>

<script>
	import { NavBar, PullRefresh, List } from 'vant'
	import trendCard from '../components/trendCard.vue'

	export default {
	  components: { trendCard, NavBar, PullRefresh, List },
    data () {
      return {
        list: [],
        page: 1,
        size: 20,
        error: false,
        loading: false,
        finished: false,
        refreshing: false
      }
    },
		methods: {
      onRefresh(param) {
        this.finished = false;
        this.loading = true;
        this.onLoad(param);
      },
      onLoad(condition) {
        if (this.refreshing) {
          this.page = 1;
          this.list = [];
          this.refreshing = false;
        }

        const targetParam = {
          page: this.page++,
          size: this.size
        };

        this.$store.dispatch('fetchMarket', {...targetParam, ...condition})
          .then(({rows, total}) => {
            this.list = [].concat(this.list, rows);
            this.loading = false;
            if (this.list.length >= total) {
              this.finished = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.error = true
            this.finished = true;
          })
      }
		}
	}
</script>

<style lang="less" scoped>
.trend-card {
	margin-bottom: 10px;
}
</style>
